import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Logo from '../common/Logo';
import useMenuModal from '../../hooks/useMenuModal';
import useRouting from '../../hooks/useRouting';
import animA from '../../animations/animA';
// import useMegaMenu from '../../hooks/useMegaMenu';
import { project } from '../../data/data';
import Button from '../common/Button';


const Navbar = () => {
  const { navbarlinks } = useRouting();
  const { isOpen, onClose } = useMenuModal();

  const inactive = 'flex items-center bg-blend-exclusion= max-h-16 text-white max-sm:text-5xl relative capitalize dim muted hover:!text-white hover:unmute transition px-4 py-6 z-[90] group'
  const active = inactive + '!text-white font-medium !nodim !unmute'

  const { duration, ease } = animA()


  const handleClose = () => onClose();
  // const { id, expand, onExpand, onCollapse } = useMegaMenu();
  // const pathname = useLocation();

  // const hasRoutes = navbarlinks.map((item, index) => item.groupRoutes ? index : -1).filter(index => index !== -1)
  // const theseHaveRoutes = hasRoutes.map(index => navbarlinks[index]?.section).filter(Boolean)


  return (
    <>
      <nav
        className={twMerge(
          'fixed group flex items-center inset-x-0 mx-auto bg-gradient-to-b from-background/80 lg:from-background/80  max-sm: backdrop-blur-sm  z-[100] quick animate-slidedown',
          // expand && 'bg-dark border-none'
        )}
      >

        <div className='relative flex w-full items-center min-h-11'>
          <div className='resp w-full h-16 flex items-center z-[1] justify-between '>
            <Link to={'/'} className='flex relative'><Logo /></Link>
            <div className='flex items-center'>
              <div className='DESK w-fit left-0 z-[2] center '>
                <div className='flex items-center'>
                  {navbarlinks.map((item, i) => (
                    <div
                      key={item + i}
                      // onMouseEnter={() => onExpand(item.section)}
                      // onMouseLeave={onCollapse}
                      className='z-[2] h-fit'
                    >
                      <>
                        <NavLink to={item.href && item.href} className={({ isActive }) => isActive ? active : inactive}>
                          <p className='text-sm'>{item.section}</p>
                          {/*  {expand && item.section === id && theseHaveRoutes.includes(id) &&
                            <div className='absolute inset-x-1 inset-y-2 bg-white/10 rounded-lg mix-blend-difference' />
                          } */}
                        </NavLink>

                        {/* EXPANDED MENU */}
                        {/*   <AnimatePresence mode='wait'>
                          {item.groupRoutes && item.section === id && (
                            <motion.div id='DESKMenu'
                              className={twMerge('DESK z-[0]',
                                'fixed inset-x-0 h-[50vh] !right-0 top-16 bg-gradient-to-tl from-neutral-950 to-dark  border-y border1',
                              )}
                              initial={{ height: '0vh', overflowY: 'clip' }}
                              animate={{
                                height: item.groupRoutes && '60vh', overflowY: 'clip', transition: { ease, duration: 0.3 }
                              }}
                              exit={{ height: '0vh', overflowY: 'clip', transition: { ease, delay: 0.1 } }}
                              transition={{ duration: 0.4, ease }}
                            >
                              <div className={twMerge('resp lg:pl-[30%]= lg:pr-[10%]= py-10 text-white')}>
                                <div className='hidden absolute inset-y-0 w-[30%] left-0 pr-8'>
                                  <div className='relative flex flex-col center full *:full *:object-cover'>
                                    <ImageMedia src={require(`../../projects/finesse-fabrics/_cover.jpg`)} />
                                  </div>
                                </div>

                                <div className='flex flex-col gap-8'>

                                  {item.groupRoutes?.map((group, j) => (
                                    <div key={group.groupLabel + j} className='flex flex-col overflow-y-scroll scrollbar-hide pointer-events-auto'>
                                      <h4 className='text-dark= muted dim animate-slideup capitalize noaction'>
                                        <span>{group.groupLabel}</span>
                                      </h4>

                                      <div className='flex flex-col h-full overflow-y-scroll scrollbar-hide'>
                                        <div className='flex flex-wrap gap-x-3 gap-y-1 h-fit leading-tight '>
                                          {group.routes.map((route, r) => {

                                            const prInactive = "relative flex group items-center break-inside-avoid text-black= *:!font-light dim hover:nodim quicker"
                                            const prActive = twMerge(prInactive + "unmute !nodim !text-white")
                                            const reIndex = String(r + 1).padStart(3, "00")

                                            return (
                                              <NavLink
                                                onMouseEnter={toHover}
                                                onMouseLeave={toDefault}
                                                key={route.label}
                                                onClick={onCollapse}
                                                to={'/' + route.link}
                                                className={({ isActive }) => isActive ? prActive : prInactive}
                                              >
                                                <h2 className='!capitalize'>
                                                  {route.label}
                                                  {r < group.routes.length - 1 && <span className='ml-1 group-hover:dim'>, </span>}
                                                </h2>
                                              </NavLink>
                                            )
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence> */}
                      </>
                    </div>
                  ))}
                </div>
              </div>
              <MenuButton />
            </div>
          </div>
        </div >
      </nav >


      {/* FOCUS OVERLAY FOR MENU EXPANSION */}
      {/* {expand &&
        <AnimatePresence mode='wait'>
          {theseHaveRoutes.includes(id) &&
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: .6 }}
              exit={{ opacity: 0 }}
              transition={{ ease, duration }}
              className='fixed z-[10] inset-0 bg-black DESK pointer-events-none select-none'
            />
          }
        </AnimatePresence>
      } */}

      <>
        <AnimatePresence mode='wait'>
          {isOpen &&
            <motion.div id='routesMob'
              className={twMerge('flex flex-col fixed items-start inset-0 z-[99] bg-background',)}
              initial={{ clipPath: 'inset(-1vh 0vw -1vh)', transition: { ease, duration, delay: 0 } }}
              animate={{ clipPath: isOpen && "inset(0%)", transition: { ease, duration } }}
              exit={{ clipPath: 'inset(-1vh 0vw 100vh)', transition: { ease, duration, delay: 0.2 } }}
              // transition={{ duration: .75, ease: [0.76, 0, 0.24, 1], }}
            >
              <div className='MOB relative center full'>
                <ul className='flex flex-col items-start -mt-[10vh]'>
                  <AnimatePresence mode='wait'>
                    {isOpen &&
                      navbarlinks.map((item, i) => (
                        <motion.li key={item.section + i} onClick={handleClose}
                          initial={{ y: 50, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration, ease, delay: 0.2 * i }}
                        >
                          <NavLink to={item.href && item.href} className={({ isActive }) => (isActive ? active : inactive)}>
                            <h2>{item.section}</h2>
                          </NavLink>
                        </motion.li>
                      ))}
                  </AnimatePresence>
                </ul>
                <div className='absolute bottom-0 mb-20 landscape:contactButtonsDiv padding inset-x-0 origin-bottom pointer-events-none'>
                  <ul className='flex flex-row landscape:flex-col landscape:contactButtons lg:flex-col items-center justify-evenly w-full'>
                    <AnimatePresence mode='sync' >
                      {isOpen &&
                        project.contacts.map((contact, i) => {
                          return (
                            <motion.li key={contact.label + i}
                              initial={{ y: 50, opacity: 0, scale: 1.5 }}
                              animate={{ y: 0, opacity: 1, scale: 1 }}
                              exit={{ y: -20 * (i + 20), opacity: 0, }}
                              transition={{ duration, ease, delay: 0.1 * i + .5 }}
                              >

                              <Link id={contact.label} target='_blank' to={contact.onClick} key={contact + i} className='flex items-start justify-start pointer-events-auto'>
                                <div className='flex shrink-0'>
                                  <Button variant={"discreet"} className='flex flex-col center rounded-full border border1 aspect-square size-14'>
                                    <i className={`${contact.icon} ri-lg`} />
                                  </Button>
                                </div>
                                <p className='hidden lg:flex  ml-10 text-left text-sm'>{contact.value}</p>
                              </Link>

                            </motion.li>
                          )
                        })}
                    </AnimatePresence>
                  </ul>
                </div>
              </div>
            </motion.div>
          }
        </AnimatePresence>
      </>
    </>
  )
}

const MenuButton = () => {

  const { isOpen, onOpen, onClose } = useMenuModal();

  const handleMenu = () => {
    if (!isOpen) onOpen()
    else onClose()
  };

  const line = 'w-6 bg-white h-[1px] absolute origin-center rounded-[4px]';

  return (
    <button onClick={handleMenu} className='MOB relative rounded-md overflow-hidden'>
      <div className='size-10 flex center aspect-square *:quicker'>
        <div className={twMerge(line, ' -translate-y-[.3rem]', isOpen && 'translate-y-0 w-[50%] -rotate-45')} />
        {/* <div className={twMerge('line', isOpen && 'origin-right w-0 opacity-0')}/> */}
        <div className={twMerge(line, ' translate-y-[.3rem]', isOpen && 'translate-y-0 w-[50%] rotate-45')} />
      </div>
    </button>
  )
}

export default Navbar
